module.exports = __webpack_public_path__ + "static/media/Community_Care_C3.67d7dd73.pdf";


//////////////////
// WEBPACK FOOTER
// ./public/assets/pdfs/Community_Care_C3.pdf
// module id = 1326
// module chunks = 0